module.exports = __webpack_public_path__ + "img/0050.d69d2d12.gif";